<template>
  <div class="padding text-center">
    <div v-if="!$store.state.slide.showYouTubeIframe && $store.state.slide.youtubeLink">
      <p class="mb-3">
        {{ $t("watchVideo") }}
      </p>
    </div>
    <div
      class="img-slide"
      v-if="$store.state.slide.showYouTubeIframe && $store.state.slide.youtubeLink"
    >
      <iframe
        v-if="id"
        class="youtube-iframe"
        width="668"
        height="375.75"
        :src="id"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <div class="no-data" v-if="!$store.state.slide.youtubeLink">
      <p class="mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>
  </div>
</template>
<script>
import Util from '@/util'

export default {
  data() {
    return {
      id: '',
    }
  },
  watch: {
    '$store.state.slide': function () {
      this._getYouTubeLink()
    },
  },
  mounted() {
    this._getYouTubeLink()
  },
  methods: {
    _getYouTubeLink() {
      if (
        this.$store.state.slide.youtubeLink &&
        Util.isURL(this.$store.state.slide.youtubeLink)
      ) {
        const id = Util.getParamValue('v', this.$store.state.slide.youtubeLink)
        if (id) {
          this.id = `https://www.youtube.com/embed/${id}`
        } else {
          const embedIndex = this.$store.state.slide.youtubeLink.indexOf('/embed/')
          if (embedIndex != -1) {
            this.id = this.$store.state.slide.youtubeLink
          } else {
            this.id = ''
          }
        }
      } else {
        this.id = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.img-slide {
  position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  .youtube-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
